import Pusher from 'pusher-js';
import { config } from '@fortawesome/fontawesome-svg-core';

// Disable Font Awesome auto CSS injection - we import it manually in app.css
// to control layer ordering and prevent it from overriding Tailwind utilities
config.autoAddCss = false;

window.Pusher = Pusher;

// window.Pusher.logToConsole = true;
